import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@vimily/bonjoro-ui-components-v2/Button';
import { VideoPlayer, VideoPlayerPlayPausePlacement } from '@vimily/bonjoro-ui-components-v2/VideoPlayer';
import { cx } from '@emotion/css';
import { computeTextColor } from '@vimily/bonjoro-ui-components-v2';

const videoDimensions = ['w-[180px] h-[180px]', 'md:h-[280px] md:w-[280px]'];

interface VideoPreview {
  videoSource?: string;
  onBackButtonClick: () => void;
  fontColor?: string;
  primaryCtaColor?: string;
  ctaCornerRadius?: number;
  fontFamily?: string;
}

export default function VideoPreview({
  videoSource = '',
  onBackButtonClick,
  fontColor,
  primaryCtaColor,
  ctaCornerRadius = 4,
  fontFamily,
}: VideoPreview) {
  const { t } = useTranslation();

  const changeResponseButtonProps = {
    className: 'text-sm xs:text-base',
    onClick: onBackButtonClick,
    style: {
      borderRadius: `${ctaCornerRadius}px`,
      borderColor: primaryCtaColor,
      backgroundColor: primaryCtaColor,
      color: computeTextColor(primaryCtaColor),
      fontFamily,
    },
  };
  return (
    <div className='justify-center w-full h-1/2 md:h-full relative p-4 flex md:flex-col'>
      <VideoPlayer
        hideClose
        hideFullScreen
        hideNewTab
        autoPlay={false}
        muted={false}
        loop={false}
        containerClassName={cx(
          'rounded-xl overflow-hidden mx-auto',
          videoDimensions
        )}
        videoClassName={cx(videoDimensions)}
        videoUrl={videoSource}
        playPausePlacement={VideoPlayerPlayPausePlacement.Center}
      />
      <div className='flex flex-col justify-center items-center m-auto ml-3 md:ml-auto h-[180px] md:h-auto'>
        <div
          className='font-bold text-sm xs:text-base mb-2'
          style={{
            color: fontColor,
            fontFamily,
          }}
        >
          {t('testimonial:response.added')}
        </div>
        <Button {...changeResponseButtonProps}>
          {t('testimonial:response.change')}
        </Button>
      </div>
    </div>
  );
}
